import { appContextStore } from "../../../common/redux/appContext";
import { MembershipLevelsEnum } from "../enums/membershipLevelsEnum";
import { MembershipTypesEnum } from "../enums/membershipTypesEnum";
import { introCostCalculatorHook } from "../hooks/introCostCalculatorHook";
import { totalCostCalculator } from "./totalCostCalculator";
import { IWizardInitialState } from "../../redux/WizardReducer/WizardReducer.types";

const calculateTotalCost = (wizard: IWizardInitialState) => {
  const { productPrices, customerProfile } = appContextStore.getState();

  let membershipCost = wizard.upgrade
    ? 0
    : introCostCalculatorHook(
        wizard.gettingStarted.answers.disabilityQuestion === null
          ? customerProfile.disabilityIsApproved
          : wizard.gettingStarted.answers.disabilityQuestion
      );
  const baseMembershipCost = membershipCost;

  let backDues = 0;
  const hasBackDues =
    productPrices.qualifyingAndLife.backDues > 0 ||
    productPrices.life.backDues > 0;

  if (
    wizard.membershipType &&
    hasBackDues &&
    wizard.membershipType !== MembershipTypesEnum.QualifyingMember
  ) {
    if (wizard.membershipType === MembershipTypesEnum.QualifyingLifeMember) {
      backDues =
        productPrices.individualPrePay.backDuesCovered ||
        productPrices.companyPrePay.backDuesCovered
          ? 0
          : productPrices.qualifyingAndLife.backDues;
    } else {
      backDues =
        productPrices.individualPrePay.backDuesCovered ||
        productPrices.companyPrePay.backDuesCovered
          ? 0
          : productPrices.life.backDues;
    }
  }

  if (wizard.membershipType === MembershipTypesEnum.QualifyingMember) {
    membershipCost = !wizard.upgrade ? productPrices.qualifying : 0;
  } else if (
    wizard.membershipType === MembershipTypesEnum.QualifyingLifeMember
  ) {
    membershipCost = !wizard.upgrade
      ? productPrices.qualifyingAndLife.price
      : 0;
  }

  if (wizard.membershipLevel) {
    if (
      wizard.membershipLevel.selectedMembershipLevel ===
      MembershipLevelsEnum.COT
    ) {
      membershipCost +=
        productPrices.individualPrePay.courtOfTableCovered ||
        productPrices.companyPrePay.courtOfTableCovered
          ? 0
          : productPrices.additionalFees.courtOfTable;
    } else if (
      wizard.membershipLevel.selectedMembershipLevel ===
      MembershipLevelsEnum.TOT
    ) {
      if (
        !productPrices.individualPrePay.topOfTableCovered &&
        !productPrices.companyPrePay.topOfTableCovered
      ) {
        membershipCost +=
          productPrices.individualPrePay.courtOfTableCovered ||
          productPrices.companyPrePay.courtOfTableCovered ||
          (wizard.upgrade &&
            wizard.membershipLevel.beforeUpgradeMembershipLevel ===
              MembershipLevelsEnum.COT)
            ? productPrices.additionalFees.courtAndTopOfTable
            : productPrices.additionalFees.courtOfTable +
              productPrices.additionalFees.courtAndTopOfTable;
      }
    }
  }

  return {
    total: totalCostCalculator(
      productPrices.individualPrePay.lateFeesCovered ||
        productPrices.companyPrePay.lateFeesCovered ||
        wizard.upgrade
        ? 0
        : productPrices.lateFees,
      membershipCost,
      !wizard.upgrade
        ? productPrices.individualPrePay.mdrtAmount +
            productPrices.companyPrePay.mdrtAmount
        : 0,
      !wizard.upgrade ? backDues : 0
    ),
    baseMembershipCost,
  };
};

export default calculateTotalCost;
